/** Heading + helper text shown at the top of each workspace step. */
export function StepIntro({ heading, help }: { heading: string; help: string }) {
  return (
    <div className="space-y-1">
      <h2 className="text-2xl font-semibold tracking-tight">{heading}</h2>
      <p className="text-sm text-muted-foreground">{help}</p>
    </div>
  );
}
